import { render, staticRenderFns } from "./biometricVerification.vue?vue&type=template&id=2c3d921c&scoped=true"
import script from "./biometricVerification.vue?vue&type=script&lang=js"
export * from "./biometricVerification.vue?vue&type=script&lang=js"
import style0 from "./biometricVerification.vue?vue&type=style&index=0&id=2c3d921c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3d921c",
  null
  
)

export default component.exports